import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

function Contact() {
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const response = await fetch("https://formspree.io/f/xdabaklr", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    });

    if (response.ok) {
      e.target.reset(); // clear form
      navigate("/thank-you"); // redirect
    } else {
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div
      style={{
        background: "#2B2B2B",
        color: "white",
        padding: "40px 20px",
        minHeight: "100vh",
      }}
    >
      <Helmet>
        <title>Contact G Bond - Tyre Repair Manufacturer</title>
        <meta
          name="description"
          content="Contact G Bond for tyre repair patches, bonding gum, cushion gum and rubber compounds. Call or WhatsApp for bulk orders."
        />
      </Helmet>

      {/* HEADER */}
      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <h1 style={{ color: "#FFC107" }}>Contact Us</h1>
        <p>Get in touch for bulk orders, dealership and inquiries</p>
      </div>

      {/* MAIN SECTION */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "40px",
          maxWidth: "1000px",
          margin: "0 auto",
        }}
      >
        {/* LEFT: CONTACT DETAILS */}
        <div
          style={{
            flex: "1",
            minWidth: "280px",
            background: "#1C1C1C",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ color: "#FFC107" }}>Contact Details</h2>

          <p style={{ marginTop: "15px" }}>
            📞 <strong>Phone:</strong> 9828274550
          </p>

          <p>
            📧 <strong>Email:</strong> gbond329@gmail.com
          </p>

          <p>
            📍 <strong>Location:</strong> India
          </p>

          {/* WHATSAPP BUTTON */}
          <a
            href="https://wa.me/919828274550"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button
              style={{
                marginTop: "20px",
                padding: "12px 25px",
                background: "#25D366",
                border: "none",
                color: "white",
                cursor: "pointer",
                width: "100%",
                borderRadius: "5px",
              }}
            >
              Chat on WhatsApp
            </button>
          </a>
        </div>

        {/* RIGHT: CONTACT FORM */}
        <div
          style={{
            flex: "1",
            minWidth: "280px",
            background: "#1C1C1C",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <h2 style={{ color: "#FFC107" }}>Send Inquiry</h2>

          <form onSubmit={handleSubmit}>
            <input
              type="hidden"
              name="_subject"
              value="New Inquiry from G Bond Website"
            />

            <input
              type="text"
              name="name"
              placeholder="Your Name"
              style={inputStyle}
              required
            />

            <input
              type="text"
              name="phone"
              placeholder="Phone Number"
              style={inputStyle}
              required
            />

            <textarea
              name="message"
              placeholder="Your Message"
              rows="4"
              style={inputStyle}
              required
            />

            <button
              type="submit"
              style={{
                marginTop: "10px",
                padding: "12px",
                background: "#FFC107",
                border: "none",
                cursor: "pointer",
                width: "100%",
                fontWeight: "bold",
                borderRadius: "5px",
              }}
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "10px",
  marginTop: "10px",
  borderRadius: "5px",
  border: "none",
  outline: "none",
};

export default Contact;